export default `/* Ids Widget Component */
:host .flex-content,
:host ::slotted(.flex-content) {
  display: flex;
  align-items: center;
  padding: var(--ids-widget-padding-inline);
  gap: var(--ids-space-sm);
}

.ids-widget {
  background-color: var(--ids-widget-color-background);
  border: 1px solid var(--ids-widget-color-border);
  border-radius: var(--ids-widget-border-radius);
  box-shadow: var(--ids-widget-shadow);
  margin-block-end: var(--ids-widget-margin-bottom);
  height: var(--ids-widget-height);
  transition: box-shadow var(--ids-motion-duration) var(--ids-motion-linear);
  overflow: hidden;
}
.ids-widget .ids-widget-content {
  box-sizing: border-box;
  height: var(--ids-widget-content-height);
  overflow: auto;
  width: 100%;
  position: relative;
}
.ids-widget .ids-widget-content ::slotted([slot=widget-content]) {
  height: 100%;
}
.ids-widget .ids-widget-content ::slotted([slot=widget-content].overflow-auto) {
  overflow: auto;
}
.ids-widget .ids-widget-content.overflow-hidden {
  overflow: hidden;
}
.ids-widget .ids-widget-content.is-scrolling {
  box-shadow: var(--ids-scroll-shadow);
  border-top: var(--ids-scroll-color-border-top);
}
.ids-widget .ids-widget-content.has-search {
  height: var(--ids-widget-search-content-height);
}
.ids-widget .ids-widget-content.has-subtitle {
  height: var(--ids-widget-search-subtitle-content-height);
  margin-top: -4px;
  overflow: visible;
}
.ids-widget .hidden {
  display: none;
}
.ids-widget:hover {
  outline: 1px solid var(--ids-widget-color-border-hover);
  box-shadow: var(--ids-widget-color-shadow-hover);
}
.ids-widget {
  --ids-search-field-color-border-default: var(--ids-widget-search-field-color-background);
  --ids-search-field-color-background-default: var(--ids-widget-search-field-color-background);
  --ids-search-field-margin: 0px var(--ids-space-xs);
  --ids-search-field-border-radius: var(--ids-widget-search-field-border-radius);
  --ids-list-view-height: 264px;
}

:host([borderless]) .ids-widget {
  background-color: var(--ids-color-transparent);
  box-shadow: none;
  border: 1px solid transparent;
}
:host([borderless]) .ids-widget .ids-widget-content {
  border-radius: var(--ids-widget-border-radius);
}
:host([borderless]) .ids-widget:hover {
  outline: 1px solid transparent;
  box-shadow: none;
}

.ids-widget-body {
  width: 100%;
}

.ids-widget-header {
  align-items: center;
  color: var(--ids-widget-header-title-color);
  display: flex;
  padding-inline-start: var(--ids-widget-header-padding-inline);
  height: var(--ids-widget-header-height);
}
.ids-widget-header.has-subtitle {
  height: var(--ids-widget-header-subtitle-height);
}
.ids-widget-header.is-empty {
  height: 0;
  padding-inline-start: 0;
}

::slotted([slot=widget-actions]) {
  position: absolute;
  margin-inline-start: var(--ids-widget-actions-margin-inline-start);
  margin-top: 15px;
}

::slotted([slot=widget-header]) {
  position: relative;
  width: 100%;
}

::slotted([slot=widget-search]) {
  height: var(--ids-widget-search-height);
}

::slotted([slot=widget-content]) {
  --ids-data-grid-height-min: 0;
}

.ids-widget-footer {
  display: none;
  border-top: 1px solid var(--ids-widget-divider-color-border);
  width: 100%;
  padding: var(--ids-space-xs) 0;
}

.has-footer .ids-widget-footer {
  display: block;
}
.has-footer .ids-widget-content {
  --ids-widget-height: 250px;
  --ids-widget-content-height: 260px;
  --ids-list-view-height: 254px;
}

:host([size=quarter]) .ids-widget {
  --ids-widget-height: var(--ids-widget-size-quarter-height);
  box-sizing: border-box;
  width: var(--ids-widget-size-quarter-width);
}

:host([size=half]) .ids-widget {
  --ids-widget-height: var(--ids-widget-size-half-height);
  --ids-kpi-width: calc(var(--ids-widget-size-half-width) - 33px);
  --ids-widget-actions-margin-inline-start: var(--ids-widget-actions-size-half-margin-inline-start);
  box-sizing: border-box;
  width: var(--ids-widget-size-half-width);
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`;
